'use client';

import { useEffect, useRef } from 'react';
import Image from 'next/image';

const logos = [
  { src: "/logotypes/logo notcoin.png", alt: "Notcoin" },
  { src: "/logotypes/logo coub.png", alt: "Coub" },
  { src: "/logotypes/logo top.png", alt: "Top" },
  { src: "/logotypes/logo u-nest.png", alt: "U-Nest" },
  { src: "/logotypes/logo B.png", alt: "Logo B" },
  { src: "/logotypes/logo bitget.png", alt: "Bitget" },
];

export default function AutoScrollLogos() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const animationFrameRef = useRef<number | undefined>(undefined);
  const scrollAmountRef = useRef(0);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    const content = scrollContainer.querySelector('.logo-content') as HTMLElement;
    if (!content) return;

    const speed = 0.5; // Скорость прокрутки в пикселях за кадр

    const animate = () => {
      if (!scrollContainer || !content) return;
      
      scrollAmountRef.current += speed;
      const contentWidth = content.scrollWidth / 2;
      
      if (scrollAmountRef.current >= contentWidth) {
        scrollAmountRef.current = 0;
      }
      
      scrollContainer.scrollLeft = scrollAmountRef.current;
      animationFrameRef.current = requestAnimationFrame(animate);
    };

    // Проверяем, нужно ли включить авто-прокрутку (только для узких экранов)
    const checkAndStart = () => {
      if (window.innerWidth < 1024) {
        if (animationFrameRef.current) {
          cancelAnimationFrame(animationFrameRef.current);
        }
        scrollAmountRef.current = 0;
        scrollContainer.scrollLeft = 0;
        animate();
      } else {
        if (animationFrameRef.current) {
          cancelAnimationFrame(animationFrameRef.current);
        }
        scrollAmountRef.current = 0;
        scrollContainer.scrollLeft = 0;
      }
    };

    checkAndStart();
    const handleResize = () => {
      checkAndStart();
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, []);

  return (
    <div className="mb-8 sm:mb-12 lg:mb-[60px]">
      {/* Desktop view */}
      <div className="hidden lg:flex lg:items-center lg:justify-between lg:gap-0">
        {logos.map((logo, index) => (
          <div key={index} className="h-[60px] w-[150px] relative">
            <Image src={logo.src} alt={logo.alt} width={150} height={60} className="object-contain" />
          </div>
        ))}
      </div>

      {/* Mobile/Tablet view with auto-scroll */}
      <div
        ref={scrollRef}
        className="overflow-x-hidden overflow-y-hidden lg:hidden scrollbar-hide"
        style={{ scrollBehavior: 'auto' }}
      >
        <div className="flex items-center gap-4 sm:gap-6 logo-content">
          {/* Дублируем логотипы для бесшовной прокрутки */}
          {[...logos, ...logos].map((logo, index) => (
            <div key={index} className="h-[40px] sm:h-[50px] w-[100px] sm:w-[120px] relative flex-shrink-0">
              <Image src={logo.src} alt={logo.alt} width={150} height={60} className="object-contain" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
